import { useState, useEffect } from "react";
import { db } from "@/firebase";
import { doc, getDoc } from "firebase/firestore";
import { coursesList } from "@/data/global_config";

const Planner = () => {
  const courseCode = localStorage.getItem("courseCode");
  const orgCode    = localStorage.getItem("orgCode");
  const [plannerPage, setPlannerPage] = useState(null);
  const [loading, setLoading]         = useState(true);

  useEffect(() => {
    const fetchPlanner = async () => {
      try {
        // 1. Check global_config first
        const localPlanner = coursesList[courseCode]?.plannerPage;
        if (localPlanner) {
          setPlannerPage(localPlanner);
          setLoading(false);
          return;
        }

        // 2. Fall back to Firestore
        if (!orgCode) { setLoading(false); return; }
        const snap = await getDoc(doc(db, "CorporateClients", orgCode));
        if (snap.exists()) {
          setPlannerPage(snap.data().plannerPage || null);
        }
      } catch (err) {
        console.error("Planner fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPlanner();
  }, [courseCode, orgCode]);

  if (loading) return <div className="p-4 text-sm text-gray-400 animate-pulse">Loading planner...</div>;
  if (!plannerPage) return <div className="p-4 text-sm text-gray-400">No planner available.</div>;

  return (
    <div className="w-full h-full overflow-y-auto p-3 md:p-2">
      <iframe
        src={plannerPage}
        title="Planner"
        className="h-full w-full overflow-y-scroll rounded-md pointer-events-auto"
      />
    </div>
  );
};

export default Planner;
